module.exports = __webpack_public_path__ + "img/coat_4.bdacd691.png";